"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const react_redux_1 = require("react-redux");
const redux_1 = require("redux");
const assets_1 = require("~/assets");
const useClickOutsideHandler_1 = __importDefault(require("~/hooks/useClickOutsideHandler"));
const actions_1 = require("~/store/actions");
const consts_1 = require("~/store/consts");
const selectors_1 = require("~/store/selectors");
const ToolButton_1 = require("~/components/UI/ToolButton");
const useProjectStatus_1 = __importDefault(require("~/hooks/useProjectStatus"));
const react_i18next_1 = require("react-i18next");
const useItemReplacement_1 = __importDefault(require("~/hooks/useItemReplacement"));
const ContextMenu_scss_1 = __importDefault(require("./ContextMenu.scss"));
const Viewer_1 = __importDefault(require("../Cad3d/Viewer"));
function ContextMenu({ deleteObjectInViewer, deleteObjectsInViewer, copyObjectInViewer, isViewMode = false, }) {
    var _a;
    // Hooks
    const { t } = (0, react_i18next_1.useTranslation)('common');
    const { shouldShowReplaceMenu, openItemReplacementWidget } = (0, useItemReplacement_1.default)();
    const { isOrderCompleted, isProjectArchived } = (0, useProjectStatus_1.default)();
    const selectedTransformMode = (0, react_redux_1.useSelector)(selectors_1.selectSelectedTransformModes);
    const isItemPropertiesShown = (0, react_redux_1.useSelector)((0, selectors_1.selectIsWidgetShown)(consts_1.WIDGETS.ITEM_PROPERTIES_WIDGET));
    const contextMenu = (0, react_redux_1.useSelector)(selectors_1.selectContextMenu);
    // Action dispatchers
    const { dispatchTransformPanelTool, dispatchToggleWidget, dispatchContextMenu } = (0, redux_1.bindActionCreators)({
        dispatchTransformPanelTool: actions_1.transformPanelTool,
        dispatchToggleWidget: actions_1.toggleWidget,
        dispatchContextMenu: actions_1.toggleContextMenu,
    }, (0, react_redux_1.useDispatch)());
    // Component data
    const selectedObjects = (_a = Viewer_1.default.instance.getDesignProMain()) === null || _a === void 0 ? void 0 : _a.selectionTool.selectedObjects;
    // Handlers
    const handleRotateClick = () => {
        dispatchTransformPanelTool(consts_1.TRANSFORM_MODE.ROTATE);
        dispatchContextMenu({ show: false });
    };
    const handleResizeClick = () => {
        dispatchTransformPanelTool(consts_1.TRANSFORM_MODE.SCALE);
        dispatchContextMenu({ show: false });
    };
    const handleTranslateClick = () => {
        dispatchTransformPanelTool(consts_1.TRANSFORM_MODE.TRANSLATE);
        dispatchContextMenu({ show: false });
    };
    const handlePropertiesClick = () => {
        dispatchToggleWidget({
            widgetName: consts_1.WIDGETS.ITEM_PROPERTIES_WIDGET,
            show: !isItemPropertiesShown,
        });
        dispatchContextMenu({ show: false });
    };
    const handleCopyClick = () => {
        copyObjectInViewer();
        dispatchContextMenu({ show: false });
    };
    const handleReplaceClick = (0, react_1.useCallback)(() => {
        openItemReplacementWidget();
        dispatchContextMenu({ show: false });
    }, [dispatchContextMenu, openItemReplacementWidget]);
    const handleDeleteClick = () => {
        deleteObjectInViewer();
        dispatchContextMenu({ show: false });
    };
    const handleMultiSelectDeleteClick = () => {
        deleteObjectsInViewer();
        dispatchContextMenu({ show: false });
    };
    const wrapperRef = (0, react_1.useRef)(null);
    const elementRef = (0, react_1.useRef)(null);
    const hideContextMenu = () => dispatchContextMenu({ show: false });
    (0, useClickOutsideHandler_1.default)(wrapperRef, elementRef, hideContextMenu);
    // Sub-components
    const replaceOption = (0, react_1.useMemo)(() => {
        const showReplaceMenu = shouldShowReplaceMenu();
        if (!showReplaceMenu) {
            return null;
        }
        const disabled = isViewMode || isOrderCompleted || isProjectArchived;
        return (react_1.default.createElement(ToolButton_1.ToolButton, { className: ContextMenu_scss_1.default.option, label: t('replace'), icon: assets_1.svgReplacePart, disabled: disabled, onClick: handleReplaceClick }));
    }, [handleReplaceClick, isOrderCompleted, isProjectArchived, isViewMode, shouldShowReplaceMenu, t]);
    if (!contextMenu.show) {
        return null;
    }
    let isScalable = false;
    let isRotatable = false;
    let isMovable = false;
    if (selectedObjects) {
        [isScalable, isRotatable, isMovable] = Viewer_1.default.instance
            .getDesignProMain()
            .selectionTool.getIsScalableRotatableMovableParams();
    }
    return (react_1.default.createElement("div", { ref: wrapperRef, onContextMenu: (e) => e.preventDefault(), style: {
            '--x': `${contextMenu.x ? contextMenu.x + 16 : 16}px`,
            '--y': `${contextMenu.y ? contextMenu.y + 16 : 16}px`,
        }, className: ContextMenu_scss_1.default.container },
        contextMenu.isMultiSelectMode && (react_1.default.createElement("div", { ref: elementRef },
            react_1.default.createElement(ToolButton_1.ToolButton, { className: ContextMenu_scss_1.default.option, icon: assets_1.svgTransformMoveIcon, label: t('move'), active: selectedTransformMode === consts_1.TRANSFORM_MODE.TRANSLATE, disabled: !isMovable || isViewMode || isOrderCompleted || isProjectArchived, onClick: handleTranslateClick }),
            react_1.default.createElement(ToolButton_1.ToolButton, { className: ContextMenu_scss_1.default.option, label: t('rotate'), icon: assets_1.svgTransformRotateIcon, active: selectedTransformMode === consts_1.TRANSFORM_MODE.ROTATE, disabled: !isRotatable || isViewMode || isOrderCompleted || isProjectArchived, onClick: handleRotateClick }),
            react_1.default.createElement(ToolButton_1.ToolButton, { className: ContextMenu_scss_1.default.option, label: t('copy'), icon: assets_1.svgBasicCalendarCopy, disabled: isViewMode || isOrderCompleted || isProjectArchived, onClick: handleCopyClick }),
            replaceOption,
            react_1.default.createElement(ToolButton_1.ToolButton, { className: ContextMenu_scss_1.default.option, icon: assets_1.svgBasicDeleteIcon, label: t('delete'), disabled: isViewMode || isOrderCompleted || isProjectArchived, onClick: handleMultiSelectDeleteClick }))),
        !contextMenu.isMultiSelectMode && (react_1.default.createElement("div", { ref: elementRef },
            react_1.default.createElement(ToolButton_1.ToolButton, { className: ContextMenu_scss_1.default.option, onClick: handleRotateClick, icon: assets_1.svgTransformRotateIcon, label: t('rotate'), active: selectedTransformMode === consts_1.TRANSFORM_MODE.ROTATE, disabled: selectedTransformMode === consts_1.TRANSFORM_MODE.NONE ||
                    !isRotatable ||
                    isViewMode ||
                    isOrderCompleted ||
                    isProjectArchived ||
                    contextMenu.angled }),
            contextMenu.scalable && (react_1.default.createElement(ToolButton_1.ToolButton, { className: ContextMenu_scss_1.default.option, onClick: handleResizeClick, icon: assets_1.svgTransformResizeIcon, label: t('resize'), active: selectedTransformMode === consts_1.TRANSFORM_MODE.SCALE, disabled: selectedTransformMode === consts_1.TRANSFORM_MODE.NONE ||
                    !isScalable ||
                    isViewMode ||
                    isOrderCompleted ||
                    isProjectArchived ||
                    contextMenu.angled })),
            react_1.default.createElement(ToolButton_1.ToolButton, { className: ContextMenu_scss_1.default.option, onClick: handleTranslateClick, icon: assets_1.svgTransformMoveIcon, label: t('move'), active: selectedTransformMode === consts_1.TRANSFORM_MODE.TRANSLATE, disabled: selectedTransformMode === consts_1.TRANSFORM_MODE.NONE ||
                    !isMovable ||
                    isViewMode ||
                    isOrderCompleted ||
                    isProjectArchived }),
            react_1.default.createElement(ToolButton_1.ToolButton, { className: ContextMenu_scss_1.default.option, onClick: handlePropertiesClick, icon: assets_1.svgPropertiesWidgetIcon, label: t('properties') }),
            react_1.default.createElement(ToolButton_1.ToolButton, { className: ContextMenu_scss_1.default.option, onClick: handleCopyClick, icon: assets_1.svgBasicCalendarCopy, disabled: contextMenu.angled || isViewMode || isOrderCompleted || isProjectArchived, label: t('copy') }),
            replaceOption,
            react_1.default.createElement(ToolButton_1.ToolButton, { className: ContextMenu_scss_1.default.option, onClick: handleDeleteClick, icon: assets_1.svgBasicDeleteIcon, disabled: isViewMode || isOrderCompleted || isProjectArchived, label: t('delete') })))));
}
exports.default = ContextMenu;
